export const getBetTransactionData = async (
  transactionHash: string,
  publicClient: any
) => {
  try {
    const receipt = await publicClient.getTransactionReceipt({
      hash: transactionHash,
    })

    const logs = receipt?.logs
    const nftTransferLogs =
      logs?.filter(
        (log: any) =>
          log.topics[0] ===
            '0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef' &&
          log.topics.length === 4
      ) ?? []

    const tokenId =
      nftTransferLogs.length > 0
        ? BigInt(
            nftTransferLogs[nftTransferLogs.length - 1].topics[3]
          ).toString()
        : null

    return { tokenId }
  } catch (error) {
    console.error('Error getting bet transaction data:', error)
    return { tokenId: null }
  }
}
